// ===============================
// FAVORITE SYSTEM (Stable Version)
// ===============================

function getFavorites() {
  return JSON.parse(localStorage.getItem("favorites")) || [];
}

function saveFavorites(data) {
  localStorage.setItem("favorites", JSON.stringify(data));
}

/* -------------------------------
   お気に入り一覧描画
-------------------------------- */
function renderFavorites() {
  const container = document.getElementById("favorite-list");
  if (!container) return;

  const favorites = getFavorites();
  container.innerHTML = "";

  if (favorites.length === 0) {
    container.innerHTML = "<p class='empty-favorite'>お気に入りはありません</p>";
    return;
  }

  favorites.forEach(item => {
    container.insertAdjacentHTML(
      "beforeend",
      `
      <div class="favorite-item cart-items" data-id="${item.id}">
        <a href="${item.url}">
          <div class="cart-item__media">
            <img src="${item.image}" alt="${item.title}">
            </div>
            <div class="cart-item__details cart-item__details--drawer">
            <span>${item.title}</span>
          </div>
        </a>
        <button type="button" class="button button--simple favorite-remove" data-id="${item.id}">
          REMOVE
        </button>
      </div>
      `
    );
  });
}

/* -------------------------------
   商品ページボタン状態同期
-------------------------------- */
function syncFavoriteButtons() {
  const favorites = getFavorites();

  document.querySelectorAll(".favorite-button").forEach(btn => {
    const id = btn.dataset.productId;
    const exists = favorites.find(item => item.id === id);

    const svgIcon = `
      <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M1 5.10326C1 2.83868 2.9283 1 5.31342 1C6.33207 1 7.26572 1.33655 8.00051 1.89689C8.73704 1.33629 9.67276 1 10.6866 1C13.0717 1 15 2.83868 15 5.10326C15 7.40865 13.8684 9.21697 12.5499 10.4963C11.2444 11.7631 9.69872 12.5706 8.68519 12.8991C8.45088 12.9765 8.20232 13 8 13C7.79768 13 7.54912 12.9765 7.31481 12.8991C6.30128 12.5706 4.75563 11.7631 3.45013 10.4963C2.13162 9.21697 1 7.40865 1 5.10326Z" fill="white" stroke="#C1BCFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;

    if (exists) {
      btn.classList.add("is-active");
      btn.innerHTML = svgIcon + " お気に入り追加済み";
    } else {
      btn.classList.remove("is-active");
      btn.innerHTML = svgIcon + " お気に入りに追加";
    }
  });
}

/* -------------------------------
   追加・削除クリック処理
-------------------------------- */
document.addEventListener("click", function (e) {

  /* ---------- 追加/切替 ---------- */
  const addBtn = e.target.closest(".favorite-button");
  if (addBtn) {
    e.preventDefault();
    e.stopPropagation();

    const id = addBtn.dataset.productId;
    const title = addBtn.dataset.productTitle;
    const image = addBtn.dataset.productImage;
    const url = addBtn.dataset.productUrl;

    let favorites = getFavorites();
    const exists = favorites.find(item => item.id === id);

    if (exists) {
      favorites = favorites.filter(item => item.id !== id);
    } else {
      favorites.push({ id, title, image, url });
    }

    saveFavorites(favorites);
    renderFavorites();
    syncFavoriteButtons();
    return;
  }

  /* ---------- REMOVE ---------- */
  const removeBtn = e.target.closest(".favorite-remove");
  if (removeBtn) {
    const id = removeBtn.dataset.id;

    let favorites = getFavorites();
    favorites = favorites.filter(item => item.id !== id);

    saveFavorites(favorites);
    renderFavorites();
    syncFavoriteButtons();
  }

});

/* -------------------------------
   初期化
-------------------------------- */
document.addEventListener("DOMContentLoaded", () => {
  renderFavorites();
  syncFavoriteButtons();
});

/* -------------------------------
   カートドロワー再描画対策
-------------------------------- */
document.addEventListener("cart:refresh", () => {
  renderFavorites();
  syncFavoriteButtons();
});

document.addEventListener("drawer:open", () => {
  renderFavorites();
  syncFavoriteButtons();
});

/* 念のため */
setTimeout(() => {
  renderFavorites();
  syncFavoriteButtons();
}, 500);